import styled from 'styled-components';
import { colors } from '../../utils/colors'
import { purpleColors, slateColors } from '../ContentPages/AppLandingPage/styles';


// Define prop types for the Switch component
interface SwitchProps {
    id: string;
    toggled: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  }

const SwitchInput = styled.input`
  height: 0;
  width: 0;
  visibility: hidden;
`;

const SwitchLabel = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  width: 3.25rem;
  height: 2rem;
  background: ${slateColors[200]};
  border-radius: 9999px;
  position: relative;
  transition: background-color 0.2s;
  -webkit-tap-highlight-color: transparent;

  /* Change background color when the input is checked */
  ${SwitchInput}:checked + & {
    background: linear-gradient(to right, ${purpleColors[600]}, ${purpleColors[500]});
  }
`;

const SwitchButton = styled.span`
  content: "";
  position: absolute;
  top: 0.25rem;
  left: 0.25rem;
  width: 1.5rem;
  height: 1.5rem;
  flex-shrink: 0;
  border-radius: 9999px;
  transition: all 0.2s;
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  -webkit-tap-highlight-color: transparent;
  
  ${SwitchInput}:checked + ${SwitchLabel} & {
    left: calc(100% - 0.25rem);
    transform: translateX(-100%);
  }

  ${SwitchLabel}:active & {
    width: 1.75rem;
  }
`;

const Switch: React.FC<SwitchProps> = ({ id, toggled, onChange }) => {
    return (
      <>
        <SwitchInput
          id={id}
          type="checkbox"
          checked={toggled}
          onChange={onChange}
        />
        <SwitchLabel htmlFor={id}>
          <SwitchButton />
        </SwitchLabel>
      </>
    );
  };
  
export default Switch;
